<template>
  <div class="homework">
    <header>
      <span class="cursor" @click="goBack" :class="{'hide':isJiexi===3}"></span>
      <b class="title" v-if="reportShow || !progressArr.length">{{title}}</b>
      <div class="progress" v-else>
        <em
          class="cursor"
          :class="{ hide: currentIndex === 1 }"
          @click="prevQuestion"
        ></em>
        <b>{{ !progressArr.length?0:currentIndex }}/{{progressArr.length}}</b>
        <em
          class="cursor"
          :class="{ hide: currentIndex === progressArr.length || !progressArr.length }"
          @click="nextQuestion"
        ></em>
      </div>
      <i class="cursor cardbtn" :class="{'hide':reportShow || topicType!==3 || !progressArr.length}" @click="cardShow=true"></i>
      <button class="cursor reset" v-if="reportShow && isGhost" @click="resetQuestion"><i>↻</i>重新做题</button>
    </header>
    <section>
      <!-- 题目 -->
      <question
        ref="question"
        :progressArr="questionShow?progressArr:[]"
        :currentIndex ="questionShow?currentIndex:-1"
        @saveQuestionSuccess="saveQuestionSuccess"
        @correctQuestionSuccess="correctQuestionSuccess"
        @showToast="showToast"
        @questionLoadErr="loadErrorShow=2"
        :type="topicType"
        :questionRight="questionRight"
        v-if="!reportShow"
        :key="reloadQuestionKey"
      ></question>
      <!-- 报告页 -->
      <report 
        v-if="reportShow" 
        :data="allData"
        @revision="revision"
        @analysis="analysis"
      ></report>
      <!-- 解析页 -->
      <analysis
        v-if="isJiexi===2 || isJiexi===3"
        @analysisLoadErr="loadErrorShow=3"
        :progressArr="progressArr"
        :currentIndex="currentIndex"
        ref="analysis"
      ></analysis>
      <div class="empty_data" v-if="emptyDataShow">暂无题目</div>
      <div class="jiexi cursor" @click="seeJiexi" v-if="topicType===4 && isJiexi!==3">
        <b :class="{'up':isJiexi===1}" v-text="isJiexi===1?'查看解析':'查看题目'"></b>
      </div>
    </section>
    <!-- 答题卡 -->
    <card 
      v-if="cardShow" 
      :data="allData" 
      @jump="jumpQuestion"
      @submitSuccess="submitSuccess"
      @showToast="showToast"
      :type="topicType"
      @close="cardShow=false"
      @resetQuestion="resetQuestion"
    ></card>
    <!-- 你真棒动画 -->
    <motivate style="z-index:999" :answerResults="answerResults" :answerAdd="answerAdd" v-if="answerResults" @animEnd="onLottieEnd" />
    <loadError
      textColor="#0B7FC7"
      :loadErrorText="loadErrorText"
      @loadAgain="loadAgain"
      :errBtnStyle="{ color: '#0b7fc7', background: '#ffffff' }"
      v-if="loadErrorShow"
      style="z-index:90;background: #c9efff"
    />
    <loading style="z-index: 100" v-show="loadingShow"></loading>
    <alert
      :show="alertShow"
      sameTwo="小朋友，退出后未提交的题目，将不保留做题记录，是否继续？"
      :size="24"
      cancal="取消"
      btn="确认"
      @cancelEvent="alertShow = false"
      @ensure="goBack(true)"
    ></alert>
    <toast 
      :showText="showText"
      :waitTime="3000"
      v-if="showText"
      style="pointer-events: auto;"
      @toastCallBack="showText = ''"
    ></toast>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import loadError from "../../basic/loadError";
import common from "common";
import alert from "../../basic/alert";
import card from "./card.vue"
import report from "./report.vue"
import question from "./question.vue"
import analysis from "./analysis.vue"
import toast from "@/components/basic/toast.vue"
import motivate from "../video/motivate.vue"
import loading from '@/components/basic/loading.vue';
export default {
  name: "homework",
  data() {
    return {
      title:common.getSession('homeWorkTitle'),
      loadErrorShow: 0,
      alertShow: false,
      currentIndex: 1,//当前题index
      cardShow:false,//答题卡是否展示
      reportShow:false,//报告是否展示
      isJiexi:0,//0隐藏，1查看解析，2查看题目,3隐藏查看解析按钮
      allData:{},
      showText:"",//toast文案
      progressArr:[],//当前所需题目集合
      topicType:3,//3作业发题、4作业解析、5作业订正
      firstHomeWork:false,//是否是第一次答完标记
      questionShow:true,//题目是否展示
      answerResults:"",
      answerAdd:{},
      questionRight:-1,//答对答错
      loadingShow:false,
      emptyDataShow:false,
      reloadQuestionKey:0
    };
  },
  components: {
    alert,
    loadError,
    question,
    report,
    card,
    toast,
    motivate,
    analysis,
    loading
  },
  computed: {
    ...mapState(["lesson_id", "class_id", "userID", "course_id","isGhost"]),
    loadErrorText(){
      if(this.loadErrorShow===2){
        return '小朋友，题目加载失败，请点击按钮重试一下吧！'
      }else{
        return '信息获取失败，请点击按钮重新加载~'
      }
    }
  },
  created() {
    this.getData();
    this.eventHub();
  },
  methods: {
    ...mapActions([
      "exerciseIndex",
      "clearExercise"
    ]),
    //解析与题目切换
    seeJiexi(){
      if(this.isJiexi===1){
        this.isJiexi=2;
      }else{
        if(this.loadErrorShow===3){
          this.loadErrorShow = 0;
        }
        this.isJiexi=1;
      }
    },
    //设置地址栏参数
    setUrlParams({topicType}){
      this.$router.push({
        path:"/homework",
        query:{
          topicType:topicType,
        }
      })
    },
    //订正
    revision(item={}){
      const arr = [];
      this.allData.progress.forEach(v => {
        if(v.status==0)arr.push(v)
      });
      const i = arr.findIndex((v)=>{
        return item.id==v.id
      })
      this.progressArr = arr;
      this.currentIndex = i===-1?1:i+1;
      this.topicType = 5;
      this.reportShow = false;
      this.loadQuestion();
    },
    //解析
    analysis(index){
      this.progressArr = this.allData.progress;
      this.currentIndex = index;
      this.topicType = 4;
      this.reportShow = false;
      this.loadQuestion();
      this.isJiexi = 1;
    },
    //题目提交成功更新数据跳下一题
    saveQuestionSuccess(datas){
      let data = this.updateData(datas);
      // console.log(data)
      if(data.type==4){//小游戏题型，可以多次作答
        if(datas.status==1){//答对
          this.answerResults = datas.rightAnimation;
          this.questionRight = datas.status*1;
          if(!this.answerResults){
            setTimeout(()=>{this.onLottieEnd('self')},datas.timeout*1000);
          }
          // console.log('答对',data.count)
        }else{
          if(data.count===1){
            this.answerResults = datas.errorAnimation;
            this.questionRight = datas.status*1;
            this.answerAdd.toastText = "小朋友，还有两次作答机会，再试试吧！"
          }else if(data.count===2){
            this.answerResults = datas.errorAnimation;
            this.questionRight = datas.status*1;
            this.answerAdd.toastText = "小朋友，还有一次作答机会，再试试吧！"
          }else if(data.count>=3){
            setTimeout(()=>{this.onLottieEnd('self')},datas.timeout*1000);
          }
          // console.log('答错',data.count)
        }
      }else{
        this.answerResults = datas.status==1?datas.rightAnimation:datas.errorAnimation;
        setTimeout(()=>{this.onLottieEnd('self')},datas.timeout*1000);
      }
    },
    //订正成功
    correctQuestionSuccess(datas){
      let data = this.updateData(datas,'correct');
      this.questionRight = datas.status*1;
      if(datas.status==1){//答对
        this.answerResults = datas.rightAnimation;
        if(!this.answerResults){
          setTimeout(()=>{this.onLottieEnd('self')},datas.timeout*1000);
        }
        // console.log('订正正确',data.count)
      }else{
        this.answerResults = datas.errorAnimation;
        this.answerAdd.toastText = "小朋友，题目订正错误，再试一次吧！"
        // console.log('订正错误',data.count)
      }
    },
    //更新本地数据
    updateData(datas,type){
      const index = this.allData.progress.findIndex((v)=>{
        return v.id===this.progressArr[this.currentIndex-1].id;
      });
      let data = this.allData.progress[index];
      data.answerStatus = datas.answerStatus;
      data.answer = datas.answer;
      let status = datas.status;
      let count = data.count+1;
      if(type==='correct'){//订正
        status = status=='1'?2:status;
        count = data.count;
      }
      data.status = status;
      data.count = datas.count || count;
      this.progressArr[this.currentIndex-1] = data;
      this.allData.progress[index] = data;
      return data;
    },
    //答题动画执行完毕
    onLottieEnd(origin){
      if(this.topicType===5 && this.questionRight==1){//最后一题订正成功展示报告页
        const index = this.progressArr.findIndex((v)=>{
          return v.status==0;
        })
        if(index===-1){
          this.reportShow = true;
          this.topicType = 3;
        }
      }else if(this.topicType===3){//首次答题完成展示答题卡
        const data = this.progressArr[this.currentIndex-1];
        const index = this.progressArr.findIndex((v)=>{
          return v.status==-1 || (data.status==0 && data.count<3 && data.type==4);
        });
        if(index===-1 && this.firstHomeWork){
          this.cardShow = true;
          this.firstHomeWork = false;
        }
      }
      if((this.questionRight==1 || origin === 'self') && !this.cardShow){
        this.nextQuestion();
      }
      this.answerResults = "";
      this.answerAdd={};
      this.questionRight = -1;
    },
    //答题卡提交成功
    submitSuccess(){
      this.getData();
      this.cardShow = false;
      this.reportShow = true;
    },
    //重新加载
    loadAgain(){
      if(this.loadErrorShow===1 || this.loadErrorShow===4){
        this.getData(this.loadErrorShow);
      }else if(this.loadErrorShow===2){
        this.loadQuestion();
      }else if(this.loadErrorShow===3){
        this.$refs.analysis.loadAgain();
      }
      this.loadErrorShow = 0;
    },
    loadQuestion(){
      this.questionShow = false;
      setTimeout(()=>{
        this.questionShow = true;
      },500)
    },
    //题目切换关闭弹框等
    closeOther(){
      this.answerResults = "";
      this.answerAdd = {};
      this.loadErrorShow = 0;
      this.showText = ""
      this.questionRight = -1;
      this.isJiexi = this.isJiexi?1:0;
    },
    //下一题
    nextQuestion() {
      if(this.currentIndex===this.progressArr.length)return;
      this.currentIndex++;
      this.closeOther();
    },
    //上一题
    prevQuestion() {
      this.currentIndex--;
      this.closeOther();
    },
    //跳题
    jumpQuestion(index){
      this.currentIndex = index;
      this.closeOther();
    },
    //展示toast
    showToast({type,text}){
      const toastText = {
        1:"小朋友，你已经作答正确，不需要再次作答哟～",
        2:"小朋友，你的三次机会已经使用完毕，无法继续做答哟～",
        3:"小朋友，这道题目你已经订正正确，不需要再次订正啦～！",
        5:"小朋友，题干语音播放失败，请检查网络设置"
      }
      this.showText = toastText[type] || text;
    },
    eventHub(){
      this.$root.eventHub.$on("httpCancal",(data)=>{
       if(data.code==="300203" || data.code==="300205"){
          this.goBack(true)
        }
      }); 
    },
    //返回
    goBack(type) {
      if(type===true || this.reportShow){
        this.$router.push("/course");
        return;
      }
      if(this.topicType===3){
        this.alertShow = true;
        return;
      }
      if(this.topicType===4 || this.topicType===5){
        this.topicType===5 &&this.getData();
        this.isJiexi = 0
        this.reportShow=true;
        this.topicType = 3;
        this.loadErrorShow = 0;
        this.loadingShow = false;
        return;
      }      
    },
    //重置
    resetQuestion(){
      this.reportShow = false;
      this.cardShow = false;
      if(this.topicType===3){//答题时候重新做题需要请求getAllJson接口
        this.reloadQuestionKey++
      }
      this.getData(4);
    },
    //获取首页数据
    getData(type=1) {
      this.allData = {};
      this.progressArr = [];
      this.loadErrorShow = 0;
      const methodsName = type===1 ? "exerciseIndex" : 'clearExercise';
      this[methodsName]({
        classId: this.class_id,
        courseId: this.course_id,
        lessonId: this.lesson_id,
        studentId: this.userID,
      }).then(({ res, ok }) => {
        if (!ok) {
          this.loadErrorShow = type;
          return;
        }
        if(!res.progress){
          this.emptyDataShow = true;
          return;
        }
        // res.exerciseStatus = 12
        // res.progress[0].status = 0;
        // res.progress[2].status = 0
        // res.progress[4].status = 0;
        if(res.exerciseStatus==11 || res.exerciseStatus==12){
          this.reportShow = true;
          this.topicType = 3;
        }
        this.currentIndex = res.cur;
        this.progressArr = res.progress;
        this.allData = res;
        const index = res.progress.findIndex((v)=>{
          return v.status == -1;
        })
        this.firstHomeWork = res.exerciseStatus==10 && index!==-1?true:false;
        const topicType = this.$route.query.topicType;
        if(topicType==4){
          this.analysis(1);
        }else if(topicType==5){
          this.revision();
        }    
      },() => {
        this.loadErrorShow = type;
      })
      .catch(() => {
        this.loadErrorShow = type;
      });
    },
  },
  watch:{
    topicType(val){
      this.setUrlParams({topicType:val});
    }
  },
  beforeDestroy() {
    common.removeSession('homeWorkTitle');
    this.$root.eventHub.$off("httpCancal")
  },
};
</script>
<style lang="less" scoped rel="stylesheet/less">
.homework {
  position: relative;
  width: 100%;
  height: 100%;
  background: #c9efff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
header {
  position: relative;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 74px;
  background: #60C4EE;
  span {
    display: block;
    margin-left: 26px;
    width: 50px;
    height: 50px;
    background: url("../../../assets/img/common/arrow_left1.png") no-repeat center;
    background-size: 100% 100%;
    border-radius: 50%;
    &:hover {
      background: rgba(0, 0, 0, 0.08) url("../../../assets/img/common/arrow_left1.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .cardbtn {
    display: block;
    width: 52px;
    height: 52px;
    background: url("../../../assets/img/homework/card.png") no-repeat center;
    background-size: 100% 100%;
    margin-right: 43px;
  }
  .progress {
    width: 220px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  b {
    font-size: 24px;
    color: #ffffff;
  }
  em {
    display: block;
    width: 35px;
    height: 35px;
    background: url("../../../assets/img/homework/left_arrow.png") no-repeat center;
    background-size: 100% 100%;
    border-radius: 50%;
  }
  em:last-child {
    background: url("../../../assets/img/homework/right_arrow.png") no-repeat center;
    background-size: 100% 100%;
  }
  .reset{
    position: absolute;
    top: 23px;
    right: 40px;
    color: #ffffff;
    font-size: 16px;
    i{
      font-size: 22px;
      display: inline-block;
      transform: translate(-3px, 2px);
    }
  }
}
.hide {
  visibility: hidden;
}
section {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}
.jiexi{
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -74px;
  z-index: 99;
  width: 147px;
  height: 59px;
  text-align: center;
  line-height: 59px;
  background: url("../../../assets/img/homework/btn_bg.png") no-repeat;
  background-size: cover;
  b{
    color: #ffffff;
    font-size: 20px;
    background: url("../../../assets/img/homework/down_arrow.png") no-repeat left center;
    background-size: 15px;
    padding-left: 26px;
  }
  .up{
    background: url("../../../assets/img/homework/up_arrow.png") no-repeat left center;
    background-size: 15px 18px;
  }
}
.empty_data{
  text-align: center;
  position: absolute;
  font-size: 30px;
  margin-top: -60px;
  color: #0B7FC7;
}
</style>


// WEBPACK FOOTER //
// src/components/bussiness/homework/index.vue